<span class="btn-label" title="GPS" data-bs-toggle="tooltip" data-bs-placement="top">
  <i class="fas fa-map-marker-alt ag-grid-header-icon"></i>
</span>
